import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { FlagEsIcon, FlagUsIcon } from '../../../../shared/ui/icons';
import { selectTemplatesTenantAdditionalLanguages } from '../../store/templatesSlice';
import { TEMPLATE_LANGUAGE, TEMPLATE_LANGUAGE_LABEL } from '../../constants/messageTemplateKeys';
import { normalizeLanguage, tenantHasLanguageChoice } from '../../lib/languageHelpers';
import styles from './LanguageFlag.module.css';

const FLAG_BY_LANGUAGE = {
  [TEMPLATE_LANGUAGE.ENGLISH]: FlagUsIcon,
  [TEMPLATE_LANGUAGE.SPANISH]: FlagEsIcon,
};

export function LanguageFlag({ language, className = '' }) {
  const tenantAdditionalLanguages = useSelector(selectTemplatesTenantAdditionalLanguages);
  const languageKey = normalizeLanguage(language);
  const FlagIcon = FLAG_BY_LANGUAGE[languageKey];

  if (!FlagIcon) return null;
  if (!tenantHasLanguageChoice(tenantAdditionalLanguages)) return null;

  return (
    <span
      className={clsx(styles.flag, className)}
      aria-label={`Language: ${TEMPLATE_LANGUAGE_LABEL[languageKey]}`}
      role="img"
    >
      <FlagIcon />
    </span>
  );
}
